"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _Localize = require("../Localization/Localize");

var _connectToWebChat = _interopRequireDefault(require("../connectToWebChat"));

var _ErrorNotificationIcon = _interopRequireDefault(require("../Attachment/Assets/ErrorNotificationIcon"));

var _SpinnerAnimation = _interopRequireDefault(require("../Attachment/Assets/SpinnerAnimation"));

var _WarningNotificationIcon = _interopRequireDefault(require("../Attachment/Assets/WarningNotificationIcon"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var CONNECTIVITY_STATUS_DEBOUNCE = 400;

var DebouncedConnectivityStatus =
/*#__PURE__*/
function (_React$Component) {
  _inherits(DebouncedConnectivityStatus, _React$Component);

  function DebouncedConnectivityStatus(props) {
    var _this;

    _classCallCheck(this, DebouncedConnectivityStatus);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DebouncedConnectivityStatus).call(this, props));
    _this.state = {
      children: props.children,
      since: Date.now()
    };
    return _this;
  }

  _createClass(DebouncedConnectivityStatus, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      var _this$props = this.props,
          children = _this$props.children,
          interval = _this$props.interval;
      var nextChildren = nextProps.children,
          nextInterval = nextProps.interval;
      var since = this.state.since;

      if (nextChildren !== children || nextInterval !== interval) {
        clearTimeout(this.timeout);
        this.timeout = setTimeout(function () {
          _this2.setState(function () {
            return {
              children: nextChildren,
              since: Date.now()
            };
          });
        }, Math.max(0, nextInterval - Date.now() + since));
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.timeout);
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.state.children;
      return typeof children === 'function' ? children() : false;
    }
  }]);

  return DebouncedConnectivityStatus;
}(_react.default.Component);

DebouncedConnectivityStatus.defaultProps = {
  children: undefined
};
DebouncedConnectivityStatus.propTypes = {
  children: _propTypes.default.any,
  interval: _propTypes.default.number.isRequired
};

var connectConnectivityStatus = function connectConnectivityStatus() {
  for (var _len = arguments.length, selectors = new Array(_len), _key = 0; _key < _len; _key++) {
    selectors[_key] = arguments[_key];
  }

  return _connectToWebChat.default.apply(void 0, [function (_ref) {
    var connectivityStatus = _ref.connectivityStatus,
        language = _ref.language;
    return {
      connectivityStatus: connectivityStatus,
      language: language
    };
  }].concat(selectors));
};

var ConnectivityStatus = function ConnectivityStatus(_ref2) {
  var connectivityStatus = _ref2.connectivityStatus,
      language = _ref2.language,
      styleSet = _ref2.styleSet;
  return _react.default.createElement("div", {
    "aria-live": "polite",
    role: "status"
  }, _react.default.createElement(DebouncedConnectivityStatus, {
    interval: connectivityStatus === 'uninitialized' || connectivityStatus === 'error' ? 0 : CONNECTIVITY_STATUS_DEBOUNCE
  }, function () {
    return connectivityStatus === 'connectingslow' ? _react.default.createElement("div", {
      className: styleSet.warningNotification
    }, _react.default.createElement(_WarningNotificationIcon.default, null), (0, _Localize.localize)('SLOW_CONNECTION_NOTIFICATION', language)) : connectivityStatus === 'error' || connectivityStatus === 'notconnected' ? _react.default.createElement("div", {
      className: styleSet.errorNotification
    }, _react.default.createElement(_ErrorNotificationIcon.default, null), (0, _Localize.localize)('FAILED_CONNECTION_NOTIFICATION', language)) : connectivityStatus === 'uninitialized' ? _react.default.createElement("div", {
      className: styleSet.connectivityNotification
    }, _react.default.createElement(_SpinnerAnimation.default, null), (0, _Localize.localize)('INITIAL_CONNECTION_NOTIFICATION', language)) : connectivityStatus === 'reconnecting' ? _react.default.createElement("div", {
      className: styleSet.connectivityNotification
    }, _react.default.createElement(_SpinnerAnimation.default, null), (0, _Localize.localize)('INTERRUPTED_CONNECTION_NOTIFICATION', language)) : connectivityStatus === 'sagaerror' ? _react.default.createElement("div", {
      className: styleSet.errorNotification
    }, _react.default.createElement(_ErrorNotificationIcon.default, null), (0, _Localize.localize)('RENDER_ERROR_NOTIFICATION', language)) : connectivityStatus === 'reconnected' || connectivityStatus === 'connected' && false;
  }));
};

ConnectivityStatus.propTypes = {
  connectivityStatus: _propTypes.default.string.isRequired,
  language: _propTypes.default.string.isRequired,
  styleSet: _propTypes.default.shape({
    connectivityNotification: _propTypes.default.any.isRequired,
    errorNotification: _propTypes.default.any.isRequired,
    warningNotification: _propTypes.default.any.isRequired
  }).isRequired
};

var _default = connectConnectivityStatus(function (_ref3) {
  var styleSet = _ref3.styleSet;
  return {
    styleSet: styleSet
  };
})(ConnectivityStatus);

exports.default = _default;